// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7f492e96","977":"c48fea05"}[chunkId] + ".chunk.js";
};